module.exports = __webpack_public_path__ + "static/img/Picture3.ac98b67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/191014/Picture3.jpg
// module id = UVIU
// module chunks = 1